import {
  Box,
  type BoxProps,
  Skeleton as MuiSkeleton,
  type SkeletonProps,
} from '@mui/material';

/** A placeholder block: decoration, hidden from assistive tech. */
export const Skeleton = (props: SkeletonProps) => (
  <MuiSkeleton aria-hidden {...props} />
);

export type SkeletonGroupProps = BoxProps & {
  /** What is loading, e.g. "Loading stations". */
  label: string;
};

const VISUALLY_HIDDEN = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
} as const;

/**
 * The one busy region around a set of skeleton blocks. The label is real
 * (visually hidden) text inside the region: a live region announces its
 * content, not its aria-label, and every block is aria-hidden.
 */
export const SkeletonGroup = ({
  label,
  children,
  ...rest
}: SkeletonGroupProps) => (
  <Box role="status" aria-busy="true" {...rest}>
    <Box component="span" sx={VISUALLY_HIDDEN}>
      {label}
    </Box>
    {children}
  </Box>
);
